import { jsx as _jsx } from "react/jsx-runtime";
import { useLayout } from '../../hooks/useLayout';
import Dispatcher from '../dispatcher';
import PrivateAccount from '../private-account';
const Layout = ({ fallback }) => {
    const { isLoading, redirectUrl, searchParams, isPrivateAccount } = useLayout();
    if (isLoading) {
        return fallback;
    }
    if (isPrivateAccount) {
        return _jsx(PrivateAccount, {});
    }
    if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
    }
    return _jsx(Dispatcher, { searchParams: searchParams });
};
export default Layout;
